const BLANK = 'blank';
const BLUSH = 'blush';
const CREME = 'creme';
const IVORY = 'ivory';
const SNOW_LAKE = 'snow_lake';
const SAND = 'sand';
const EUCALYPTUS = 'eucalyptus';
const GARDEN_ESTATE = 'garden_estate';
const GOLDEN_NATIVE = 'golden_native';
const LA_BUTTE = 'la_butte';
const ROSEY = 'rosey';
const BOHEMIAN_EUCALYPTUS = 'bohemian_eucalyptus';
const CLASSICAL_PEONIES = 'classical_peonies';
const FLORAL_CROWN_GEORGIA = 'floral_crown_georgia';
const GOLD_FOIL_FRAME = 'gold_foil_frame';
const GOLDEN_HOUR = 'golden_hour';
const SPRING_BOUQUET = 'spring_bouquet';
const DIAMOND_LOVE = 'diamond_love';
const KING_PROTEA = 'king_protea';
const SOPHIA_KAPLAN = 'sophia_kaplan';
const SARULEAN = 'sarulean';
const RED_PEONY = 'red_peony';
const OLIVE = 'olive';
const MODERN_SIMPLICITY = 'modern_simplicity';
const MOD_BOTANICAL = 'mod_botanical';
const MODERN_MODE = 'modern_mode';
const LUNA = 'luna';
const LEAVES = 'leaves';
const KANDARA = 'kandara';
const GRAPHITE_BLOOMS = 'graphite_blooms';
const FIDDLE_FIG_LEAF = 'fiddle_fig_leaf';
const BEACH = 'beach';
const TROPICAL_LEAVES = 'tropical_leaves';
const TROPICAL_OASIS = 'tropical_oasis';
const LEIF = 'leif';
const DELICATE_LAVENDER = 'delicate_lavender';
const AUSTRALIAN_NATIVE_COLOUR_IN = 'australian_native_colour_in';

export const newThemeNames = [
  BLANK,
  BLUSH,
  CREME,
  IVORY,
  SNOW_LAKE,
  SAND,
  EUCALYPTUS,
  GARDEN_ESTATE,
  GOLDEN_NATIVE,
  LA_BUTTE,
  ROSEY,
  BOHEMIAN_EUCALYPTUS,
  CLASSICAL_PEONIES,
  FLORAL_CROWN_GEORGIA,
  GOLD_FOIL_FRAME,
  GOLDEN_HOUR,
  SPRING_BOUQUET,
  DIAMOND_LOVE,
  KING_PROTEA,
  SOPHIA_KAPLAN,
  SARULEAN,
  RED_PEONY,
  OLIVE,
  MODERN_SIMPLICITY,
  MOD_BOTANICAL,
  MODERN_MODE,
  LUNA,
  LEAVES,
  KANDARA,
  GRAPHITE_BLOOMS,
  FIDDLE_FIG_LEAF,
  BEACH,
  TROPICAL_LEAVES,
  TROPICAL_OASIS,
  LEIF,
  DELICATE_LAVENDER,
  AUSTRALIAN_NATIVE_COLOUR_IN
];
